/* eslint-disable consistent-return */
import { Spin } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { useAppSelector } from 'app/store';
import Icon from 'common/components/Icon';
import SummaryCard from 'common/components/SummaryCard';
import { getCounterResultV3Service, getKioskAnnalyticV3Service } from 'common/services/dashboard';
import roles, { getPermission } from 'configs/roles';
import KioskAverageYearOld from 'extends/EpidemiologyAnnalysis/KioskAverageYearOld';
import KioskGenderAnalytic from 'extends/EpidemiologyAnnalysis/KioskGenderAnalytic';
import KioskSmoking from 'extends/EpidemiologyAnnalysis/KioskSmoking';
import HeaderKiosk from 'extends/HeaderKiosk';
import KioskDashboardFilter from 'extends/KioskDashboardFilter';

const EpidemiologyManagement = () => {
  const rolesUser = useAppSelector((state) => state.auth.roles);
  const { t } = useTranslation();
  const [typeParam, setTypeParam] = useState<number | undefined>(undefined);
  const [kiosGroupId, setKiosGroupId] = React.useState<number[]>([]);
  const [dateRange, setDateRange] = React.useState<string[]>(['2023-03-01', moment().format('YYYY-MM-DD')]);

  const {
    data: kiosAnalyticData, refetch, isFetching
  } = useQuery(
    ['getKioskAnnalyticV3Query2'],
    () => getKioskAnnalyticV3Service({
      from: dateRange[0],
      to: dateRange[1],
      ...(typeParam && { type: typeParam }),
      ...(kiosGroupId.join(',') && { kioskGroupIds: kiosGroupId.join(',') }),
    }),
  );

  const {
    data: kiosCounterData, refetch: refetchCounter
  } = useQuery(
    ['getCounterResultV3Query2-epi'],
    () => getCounterResultV3Service({
      from: dateRange[0],
      to: dateRange[1],
      ...(typeParam && { type: typeParam }),
      ...(kiosGroupId.join(',') && { kioskGroupIds: kiosGroupId.join(',') }),
    }),
  );

  const handleClear = () => {
    setDateRange([]);
    setTypeParam(undefined);
    setKiosGroupId([]);
  };

  return (
    <div className="epidemiology">
      <HeaderKiosk
        icon={<Icon iconName="global2" />}
        title={t('dashboard2025.epidemiology')}
      />
      <div className="epidemiology-wrapper">
        <div className="epidemiology-filter">
          <KioskDashboardFilter
            typeParam={typeParam}
            setTypeParam={setTypeParam}
            kiosGroupId={kiosGroupId}
            setKiosGroupId={setKiosGroupId}
            dateRange={dateRange}
            setDateRange={setDateRange}
            onClear={handleClear}
            onRefetch={refetch}
            onRefetch2={refetchCounter}
          />
        </div>
        <div className="epidemiology-card">
          <SummaryCard
            variant="tim-mach"
            title={t('dashboard2025.total')}
            number={kiosCounterData?.total || 0}
          />
        </div>
        {getPermission(rolesUser, roles.REPORT_ANALYTIC) && (
          <div className="epidemiology-charts">
            <Spin spinning={isFetching}>
              <KioskGenderAnalytic gender={kiosAnalyticData?.gender} />
            </Spin>
            <Spin spinning={isFetching}>
              <KioskAverageYearOld averageYearOld={kiosAnalyticData?.age} />
            </Spin>
            <Spin spinning={isFetching}>
              <KioskSmoking smoking={kiosAnalyticData?.htl} />
            </Spin>
          </div>
        )}
      </div>
    </div>
  );
};

export default EpidemiologyManagement;
